import React from "react";
import { useTheme, fonts } from "@/theme";

export function useAdminStyles() {
  const { colors } = useTheme();
  return {
    label: { display: "block", color: colors.onSurface, fontSize: 13, fontWeight: 700, marginBottom: 6, fontFamily: fonts.text },
    input: { width: "100%", background: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 10, padding: "11px 12px", fontSize: 14, color: colors.onSurface, fontFamily: fonts.text, outline: "none", boxSizing: "border-box" },
    field: { marginBottom: 16 },
    hint: { color: colors.muted, fontSize: 12, marginTop: 4, fontFamily: fonts.text },
  };
}

export function Field({ label, hint, children }) {
  const s = useAdminStyles();
  return (
    <div style={s.field}>
      {label ? <label style={s.label}>{label}</label> : null}
      {children}
      {hint ? <div style={s.hint}>{hint}</div> : null}
    </div>
  );
}

export function TextField({ value, onChange, multiline, rows = 4, ...props }) {
  const s = useAdminStyles();
  if (multiline) {
    return <textarea value={value ?? ""} onChange={(e) => onChange(e.target.value)} rows={rows} style={{ ...s.input, resize: "vertical", minHeight: rows * 22 }} {...props} />;
  }
  return <input value={value ?? ""} onChange={(e) => onChange(e.target.value)} style={s.input} {...props} />;
}

export function Toggle({ label, checked, onChange, testId }) {
  const { colors } = useTheme();
  return (
    <button data-testid={testId} type="button" onClick={() => onChange(!checked)} style={{ display: "flex", alignItems: "center", gap: 10, background: "transparent", border: "none", cursor: "pointer", padding: "6px 0", marginBottom: 12 }}>
      <div style={{ width: 44, height: 26, borderRadius: 999, background: checked ? colors.brand : colors.borderStrong, position: "relative", transition: "background 0.15s" }}>
        <div style={{ position: "absolute", top: 3, left: checked ? 21 : 3, width: 20, height: 20, borderRadius: 999, background: "#fff", transition: "left 0.15s" }} />
      </div>
      <span style={{ color: colors.onSurface, fontSize: 14, fontWeight: 600, fontFamily: fonts.text }}>{label}</span>
    </button>
  );
}

export function SaveBar({ onSave, saving, onDelete, saveLabel = "Save" }) {
  const { colors } = useTheme();
  return (
    <div style={{ display: "flex", gap: 10, marginTop: 8, position: "sticky", bottom: 0, background: colors.surface, padding: "12px 0" }}>
      <button data-testid="admin-save-button" className="pressable" onClick={onSave} disabled={saving} style={{ flex: 1, background: colors.brandPrimary, color: colors.onBrandPrimary, border: "none", borderRadius: 12, padding: "14px", cursor: "pointer", fontSize: 15, fontWeight: 700, fontFamily: fonts.text, opacity: saving ? 0.7 : 1 }}>{saving ? "Saving…" : saveLabel}</button>
      {onDelete ? <button data-testid="admin-delete-button" className="pressable" onClick={onDelete} style={{ background: "transparent", color: colors.error, border: `1px solid ${colors.error}`, borderRadius: 12, padding: "14px 18px", cursor: "pointer", fontSize: 15, fontWeight: 700, fontFamily: fonts.text }}>Delete</button> : null}
    </div>
  );
}

export function listToText(arr) { return (arr || []).join("\n"); }
export function textToList(text) { return (text || "").split("\n").map((s) => s.trim()).filter(Boolean); }
